export const CONTENT_SITE_TITLES = {
  faq: __("content.pages.faq.title"),
  team: __("content.pages.team.title"),
  refund: __("refund.title"),
  privacy: __("content.pages.privacy.title"),
  media: __("content.pages_v2.media.press_kit"),
  legal: __("content.pages.legal.title"),
  investors: __("content.pages.investors.title"),
  about: __("content.pages.about.title"),
  account: __("content.pages.account.title"),
  business: __("content.pages.business.title"),
  cookies: __("content.pages.cookies.title"),
  cookies_settings: __("content.pages.cookies_settings.title"),
  mobile: __("content.pages.mobile.title"),
  feedback: __("content.pages.feedback.get_support"),
  guarantee: __("content.pages.guarantee.title"),
  careers: __("content.pages.careers.title"),
  manage: __("content.pages.manage.title"),
  support: __("content.pages.support.title"),
  stories: __("content.stories"),
  security: __("content.pages.security_title"),
  branding: __("content.branding"),
  invite: __("pages.buddy.landing.title"),
  gdpr_terms: __("content.pages.terms.title"),
}

export const PRIVACY_CATEGORIES = {
  WHO: "who",
  TERMS: "terms",
  DATA: "data",
  PURPOSES: "purposes",
  SHARE: "share",
  HOW_LONG: "how_long",
  ACCESS: "access",
  COOKIES: "cookies",
  TRANSFERRING: "transferring",
  SUPERVISORY: "supervisory",
}

export type PrivacyTranslation = {
  tKey: string,
  values?: Object, // eslint-disable-line flowtype/no-weak-types
}

type PrivacyData = {
  [string]: {
    title: string,
    content: Array<PrivacyTranslation>,
  },
}

export const PRIVACY_DATA: PrivacyData = {
  [PRIVACY_CATEGORIES.WHO]: {
    title: __("content.privacy.who.title"),
    content: [{ tKey: __("content.privacy.who.content") }],
  },
  [PRIVACY_CATEGORIES.TERMS]: {
    title: __("content.privacy.terms.title"),
    content: [{ tKey: __("content.privacy.terms.content") }],
  },
  [PRIVACY_CATEGORIES.DATA]: {
    title: __("content.privacy.data.title"),
    content: [{ tKey: __("content.privacy.data.content") }],
  },
  [PRIVACY_CATEGORIES.PURPOSES]: {
    title: __("content.privacy.purposes.title"),
    content: [{ tKey: __("content.privacy.purposes.content") }],
  },
  [PRIVACY_CATEGORIES.SHARE]: {
    title: __("content.privacy.share.title"),
    content: [
      { tKey: __("content.privacy.share.controllers") },
      { tKey: __("content.privacy.share.controllers_table") },
      { tKey: __("content.privacy.share.processors") },
      { tKey: __("content.privacy.share.processors_table") },
    ],
  },
  [PRIVACY_CATEGORIES.HOW_LONG]: {
    title: __("content.privacy.how_long.title"),
    content: [{ tKey: __("content.privacy.how_long.content") }],
  },
  [PRIVACY_CATEGORIES.ACCESS]: {
    title: __("content.privacy.access.title"),
    content: [
      { tKey: __("content.privacy.access.content") },
      { tKey: __("content.privacy.access.more") },
    ],
  },
  [PRIVACY_CATEGORIES.COOKIES]: {
    title: __("content.privacy.cookies.title"),
    content: [
      {
        tKey: __("content.privacy.cookies.content"),
        values: {
          cookiesUrl: "/pages/cookies_settings",
        },
      },
      { tKey: __("content.privacy.cookies.more") },
    ],
  },
  [PRIVACY_CATEGORIES.TRANSFERRING]: {
    title: __("content.privacy.transferring.title"),
    content: [{ tKey: __("content.privacy.transferring.content") }],
  },
  [PRIVACY_CATEGORIES.SUPERVISORY]: {
    title: __("content.privacy.supervisory.title"),
    content: [{ tKey: __("content.privacy.supervisory.content") }],
  },
}

type PrivacyDataShowMore = [
  "content.privacy.share.controllers_table",
  "content.privacy.share.processors_table",
  "content.privacy.access.more",
  "content.privacy.cookies.more",
]

export const PRIVACY_DATA_SHOW_MORE: PrivacyDataShowMore = [
  "content.privacy.share.controllers_table",
  "content.privacy.share.processors_table",
  "content.privacy.access.more",
  "content.privacy.cookies.more",
]
